// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
    if (!String.prototype.includes) {
        String.prototype.includes = function (search, start) {
            'use strict';
            if (typeof start !== 'number') {
                start = 0;
            }

            if (start + search.length > this.length) {
                return false;
            } else {
                return this.indexOf(search, start) !== -1;
            }
        };
    }

var baseUrl = '/';
/* App Module */

var hq = angular.module('hq', ['ngRoute', 'hqFilters', 'hqServices', 'ui', 'ui.bootstrap', 'nvd3ChartDirectives', 'globalControllers', 'ngUpload']);

hq.linkVersion = '?21';

hq.
config(['$routeProvider', '$httpProvider', function ($routeProvider, $httpProvider) {
    var interceptor = ['$rootScope', '$q', function (scope, $q) {

        function success(response) {
            return response;
        }

        function error(response) {
            var status = response.status;

            if (status == 401) {
                var deferred = $q.defer();
                var req = {
                    config: response.config,
                    deferred: deferred
                };
                window.location = "/#/login";
            } else if (response.data) {
                var message = response.data.Message || response.data.error_description;
                if (message)
                    scope.showErrorBox(message);
            }
            // otherwise
            return $q.reject(response);
        }

        return function (promise) {
            return promise.then(success, error);
        };
    } ];

    $httpProvider.responseInterceptors.push(interceptor);
    $routeProvider
        .when('/dashboard-operations', { templateUrl: 'partials/dashboard-operations.html'+hq.linkVersion, controller: DashboardOperationsController })
        .when('/dashboard-statistics', { templateUrl: 'partials/dashboard-statistics-overview.html'+hq.linkVersion, controller: DashboardStatisticsOverviewController })
        .when('/dashboard-statistics/:month', { templateUrl: 'partials/dashboard-statistics-monthly.html'+hq.linkVersion, controller: DashboardStatisticsMonthlyController })
        .when('/dashboard-feature-stats', { templateUrl: 'partials/dashboard-feature-stats.html' + hq.linkVersion, controller: DashboardFeatureStatsController })
        .when('/dashboard-api-usage', { templateUrl: 'partials/dashboard-api-usage.html'+hq.linkVersion, controller: DashboardAttendanceController })
        .when('/dashboard-turnovers', { templateUrl: 'partials/dashboard-turnovers.html'+hq.linkVersion, controller: DashboardTurnoversController })
        .when('/dashboard-dbtools', { templateUrl: 'partials/dashboard-dbtools.html' + hq.linkVersion, controller: DashboardDBObjectController })
        .when('/dashboard-emails', { templateUrl: 'partials/dashboard-emails.html' + hq.linkVersion, controller: DashboardEmailsController })
        .when('/login', { templateUrl: 'partials/login.html'+hq.linkVersion, controller: AuthenticationController })
        .when('/signup/:token', { templateUrl: 'partials/accountsetup.html'+hq.linkVersion, controller: AccountSetupController })
        .when('/logs', { templateUrl: 'partials/logs.html'+hq.linkVersion, controller: LogsController })
        .when('/archived', { templateUrl: 'partials/archived.html'+hq.linkVersion, controller: ArchivedLogsController })
        .when('/notifications', { templateUrl: 'partials/notifications.html'+hq.linkVersion, controller: NotificationsController })
        .when('/requestLogs-web', { templateUrl: 'partials/requestLogs-web.html'+hq.linkVersion, controller: RequestLogsWebController })
        .when('/requestLogs-hq', { templateUrl: 'partials/requestLogs-hq.html'+hq.linkVersion, controller: RequestLogsHQController })
        .when('/admin', { templateUrl: 'partials/settings/admin.html'+hq.linkVersion, controller: AdminController })
        .when('/users', { templateUrl: 'partials/users.html'+hq.linkVersion, controller: UsersController })
        .when('/jobs', { templateUrl: 'partials/jobs.html' + hq.linkVersion, controller: JobsController })
        .when('/emails', { templateUrl: 'partials/emails.html' + hq.linkVersion, controller: EmailsController })
        .when('/actions/prometheus-actions', { templateUrl: 'partials/actions/prometheus/prometheus-actions.html' + hq.linkVersion, controller: PrometheusActionsController })
        .when('/actions/prometheus-instances', { templateUrl: 'partials/actions/prometheus/prometheus-instances.html' + hq.linkVersion, controller: PrometheusInstancesController })
        .when('/actions/prometheus-charts', { templateUrl: 'partials/actions/prometheus/prometheus-charts.html' + hq.linkVersion, controller: PrometheusChartsController })
        .when('/actions/psp-analytics', { templateUrl: 'partials/actions/prometheus/psp-analytics.html' + hq.linkVersion, controller: PrometheusPspAnalyticsController })
        .when('/actions/backbeat-actions', { templateUrl: 'partials/actions/backbeat/backbeat-actions.html' + hq.linkVersion, controller: BackbeatActionsController })
        .when('/entities', { templateUrl: 'partials/entities.html'+hq.linkVersion, controller: EntitiesController })
        .when('/entities/:entityId', { templateUrl: 'partials/entity-details.html' + hq.linkVersion, controller: EntityDetailsController })
        .when('/entities/:entityId/settings', { templateUrl: 'partials/entity-settings.html' + hq.linkVersion, controller: EntitySettingsController })
        .when('/entities/:entityId/customers/:customerId', { templateUrl: 'partials/customer-details.html'+hq.linkVersion, controller: CustomerDetailsController })
        .when('/rateLimits', { templateUrl: 'partials/rateLimits.html'+hq.linkVersion, controller: RateLimitsController })
        .when('/lockedContracts', { templateUrl: 'partials/lockedContracts.html'+hq.linkVersion, controller: LockedContractsController })
        .when('/oauth', { templateUrl: 'partials/oauth.html'+hq.linkVersion, controller: OAuthController })
        .when('/profiler', { templateUrl: 'partials/profiler.html'+hq.linkVersion, controller: ProfilerController })
        .when('/payments', { templateUrl: 'partials/payments.html' + hq.linkVersion, controller: PaymentTransactionsController })
        .when('/payments/:paymentId', { templateUrl: 'partials/payment.html' + hq.linkVersion, controller: PaymentTransactionModifyController })
        .when('/paymentlogs/:paymentId', { templateUrl: 'partials/paymentLogs.html' + hq.linkVersion, controller: PaymentLogsController })
        .when('/orders', { templateUrl: 'partials/orders.html' + hq.linkVersion, controller: OrdersController })
        .when('/webhooks', { templateUrl: 'partials/webhooks.html' + hq.linkVersion, controller: WebhooksController })
        .when('/invoices/:invoiceId', { templateUrl: 'partials/invoice-details.html' + hq.linkVersion, controller: InvoiceDetailsController })
        .when('/dunnings/:dunningId', { templateUrl: 'partials/dunning-details.html' + hq.linkVersion, controller: DunningDetailsController })
        .when('/requestLogs-thirdparty', {templateUrl: 'partials/requestLogs-thirdParty.html' + hq.linkVersion, controller: ThirdPartyLogController})
        .when('/requestLogs-thirdparty/:requestId', {templateUrl: 'partials/requestLogs-thirdPartyDetails.html' + hq.linkVersion, controller: ThirdPartyLogDetailsController})
        .when('/requestLogs-external-subscription', { templateUrl: 'partials/requestLogs-external-subscription.html' + hq.linkVersion, controller: ExternalSubscriptionRequestLogsController })
        .when('/payment-gateway/transactions', { templateUrl: 'partials/PaymentGateway/payment-gateway-transactions.html' + hq.linkVersion, controller: PgTransactionsController })
        .when('/payment-gateway/transactions/:transactionId', { templateUrl: 'partials/PaymentGateway/transaction-details.html'+ hq.linkVersion, controller: PgTransactionDetailsController })
        .when('/payment-gateway/system-settings', { templateUrl: 'partials/PaymentGateway/pg-system-settings.html'+ hq.linkVersion, controller: PgSystemSettingsController })
        .when('/payment-gateway/dashboard', { templateUrl: 'partials/PaymentGateway/pg-dashboard.html'+ hq.linkVersion, controller: PgDashboardController })
        .when('/payment-gateway/migrations', { templateUrl: 'partials/PaymentGateway/pg-migrations.html'+ hq.linkVersion, controller: PgMigrationsController })
        .when('/payment-gateway/app-logs', { templateUrl: 'partials/PaymentGateway/pg-logs.html'+ hq.linkVersion, controller: PgLogsController })
        .when('/payment-gateway/psp-request-logs', { templateUrl: 'partials/PaymentGateway/pg-psp-request-logs.html'+ hq.linkVersion, controller: PgPspRequestLogsController })
        .when('/payment-gateway/pg-request-logs', { templateUrl: 'partials/PaymentGateway/pg-request-logs.html'+ hq.linkVersion, controller: PgRequestLogsController })
        .when('/payment-gateway/notification-logs', { templateUrl: 'partials/PaymentGateway/pg-notification-logs.html'+ hq.linkVersion, controller: PgNotificationLogsController })
        .when('/payment-gateway/psp-reports', { templateUrl: 'partials/PaymentGateway/pg-psp-reports.html'+ hq.linkVersion, controller: PgPspReportsController })
        .otherwise({ redirectTo: '/dashboard-operations' });
}]).run(['$rootScope', '$location', '$http', '$modal', '$q', function ($rootScope, $location, $http, $modal, $q) {
    $rootScope.addMinutes = function (id, minutes) {
        var date = new Date(parseInt(id.slice(0, 8), 16) * 1000);
        return new Date(new Date(date).getTime() + minutes * 60000).toISOString();
    }
    $rootScope.linkVersion = hq.linkVersion;
    $rootScope.isValid = function (form) {
        if (form['$invalid']) {
            var errors = form['$error'];
            for (var rover in errors) {
                var arr = errors[rover];
                for (var innerRover = 0; innerRover < arr.length; innerRover++) {
                    if (arr[innerRover].$name != undefined && arr[innerRover].$name != '') {
                        var selector = ":input[name='" + arr[innerRover].$name + "']";
                        $(selector).focus();
                    }
                }
            }
            return false;
        }
        return true;
    };
    $rootScope.$watch(function () { return $location.path(); }, function (newValue) {
        // If there's no access token, we don't have to wait for the 401, redirect immediately:
        if (localStorage["access_token"] == null && newValue != '/login' && newValue.indexOf('/signup') != 0 && newValue.indexOf('/passwordReset') != 0 && newValue.indexOf('/passwordTooWeak') != 0) {
            $location.path('/login');
            return;
        }
        else if ($rootScope.access_token == null) {
            // this happens on reload, copy from local storage to root scope
            $rootScope.accessToken = localStorage["access_token"];
            $rootScope.refreshToken = localStorage["refresh_token"];
            $rootScope.username = localStorage["username"];

            if (localStorage["role"] && localStorage["role"] !== "undefined")
                $rootScope.role = localStorage["role"];

            $http.defaults.headers.common["Authorization"] = "Bearer " + localStorage["access_token"];
        }
    });
    $rootScope.messages = [];
    $rootScope.isActive = function (name) {
        var path = $location.path();
        // Using a substring search (indexOf != -1) doesn't work, because then 'catalogs' and 'logs' both
        // contain logs. Instead, we're checking whether the string starts with "/name"
        var result = path.indexOf(name) == 1;
        return result;
    };

    $rootScope.addMinutes = function (date, minutes) {
        return new Date(new Date(date).getTime() + minutes * 60000).toISOString();
    }

    $rootScope.addMinutesToId = function (id, minutes) {
        var date = new Date(parseInt(id.slice(0, 8), 16) * 1000);
        return new Date(new Date(date).getTime() + minutes * 60000).toISOString();
    }

    $rootScope.getIdTimestamp = function (id) {
        return new Date(parseInt(id.substring(0, 8), 16) * 1000).toISOString();
    };
    $rootScope.notify = function (type, message) {
        // $rootScope.messages = [];
        $rootScope.messages.push({ type: type, message: message });
    };
    $rootScope.showErrorBox = function (message) {
        if ($rootScope.skipErrorBox) {
            $rootScope.skipErrorBox = false;
            return;
        }
        var id = Math.random().toString(36).substr(2, 7);
        //$(window.document.body).append("<div id='" + id + "' class='modal hide fade'><div class='modal-header'><button type='button' class='close' data-dismiss='modal'>x</button><h3>Fehler</h3></div><div class='modal-body'>Ein Fehler ist aufgetreten!<br>" + message + "</div><div class='modal-footer'><button class='btn btn-primary' data-dismiss='modal'>OK</button></div></div>");
        var htmlEscape = function (str) {
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        };

        alert(message);
    };

    $rootScope.confirm = function (title, message, confirmCallback, cancelCallback) {
        if (!title || !message || !confirmCallback) {
            throw new Error("missing parameter");
        }

        var modalInstance = $modal.open({
            templateUrl: 'partials/controls/confirm-dialog.html',
            controller: ModalConfirmEntityCtrl,
            windowClass: "fade in",
            resolve: {
                title: function () { return title; },
                description: function () { return message; },
                confirmCallback: function () { return confirmCallback; },
                cancelCallback: function () { return cancelCallback; }
            }
        });
    };

    $rootScope.pathContains = function (name) {
        var path = $location.path();
        // this is the lazy-man's approach
        var result = path.indexOf(name) != -1;
        return result;
    };
    $rootScope.clientPaginator = function (allModels, pageSize, filterFunction, getIdFunction=null) {
        var model;
        var searchInput;
        var getId = getIdFunction ?? ((obj)=>{return obj.Id;});

        var getFirstElementIdOrDefault = () => getFilteredModels(searchInput).length > 0 ? getId(getFilteredModels(searchInput)[0]) : "";

        var currentPageKey = getFirstElementIdOrDefault();

        function getFilteredModels(searchInput) {
            return filterFunction
                ? filterFunction(allModels, searchInput)
                : allModels;
        }

        var getNextLink = function () {
            var startIndex = getFilteredModels(searchInput).findIndex(x => getId(x) === currentPageKey);
            var pageItems =  getFilteredModels(searchInput).slice(startIndex);

            if (pageItems.length > pageSize) {
                var nexPageFirstElement = getFilteredModels(searchInput)[startIndex + pageSize];
                if (nexPageFirstElement)
                    return getId(nexPageFirstElement);
            }

            return null;
        };

        var getPrevLink = function () {
            var startIndex =  getFilteredModels(searchInput).findIndex(x => getId(x) === currentPageKey);
            if(startIndex > pageSize) {
                return getId(getFilteredModels(searchInput)[startIndex - pageSize]);
            }
            else {
                return getId(getFilteredModels(searchInput)[0]);
            }
        };

        var getCurrentPageIndex = function () {
            var startIndex =  getFilteredModels(searchInput).findIndex(x => getId(x) === currentPageKey);
            if(startIndex === -1){
                return 1;
            }

            var pageIndex = Math.floor(startIndex / pageSize ) + 1;
            return pageIndex;
        };

        var update = function (pageKey) {

            var startIndex =  getFilteredModels(searchInput).findIndex(x => getId(x) === pageKey);
            var currentPageElements =  getFilteredModels(searchInput).slice(startIndex, startIndex + pageSize);

            model.items = currentPageElements;

            model.isLast = getNextLink() === null;
            model.isFirst = currentPageKey === getFirstElementIdOrDefault();
            model.pageIndex = getCurrentPageIndex();
            model.isDataAvailable = currentPageElements.length>0 || !model.isFirst;
        };

        var setPageKey = function (newPageKey) {
            if (newPageKey != null) {
                currentPageKey = newPageKey;
                update(newPageKey);
            }
        };

        var setFilter = function(input){
            searchInput = input;
            setPageKey(getFirstElementIdOrDefault());
        };

        model = {
            items: [],
            first: function () {
                var key = getFirstElementIdOrDefault();
                setPageKey(key);
            },
            next: function () {
                setPageKey(getNextLink());
            },
            prev: function () {
                setPageKey(getPrevLink());
            },
            filter: function(input){
                setFilter(input);
            },
        };

        model.first();

        return model;
    };

    $rootScope.paginator = function (fetch, options, pageSize) {
        var pageKey = "";
        var pages = {};

        var getNextLink = function (page) {
            if (!page || page.length <= pageSize)
                return null;
            return page[pageSize].Id;
        };

        var update = function () {
            var page = pages[pageKey];
            if (page)
                model.items = page.slice(0, pageSize);
            else
                model.items = []; //loading...
            model.isLast = getNextLink(page) === null;
            model.isFirst = pageKey === "";
        };

        var setPageKey = function (newPageKey) {
            pageKey = newPageKey;
            update();

            var fetchOptions = {};
            for (var name in options) {
                fetchOptions[name] = options[name];
            }
            fetchOptions.from = newPageKey;
            fetchOptions.take = pageSize + 1; //+1 for the next-link
            var tempPage = fetch(fetchOptions, function () {
                pages[newPageKey] = tempPage;
                update();
            });
        };

        var model = {
            items: [],
            first: function () {
                setPageKey("");
            },
            next: function () {
                if (!model.isLast)
                    setPageKey(getNextLink(pages[pageKey]));
            },
            prev: function () {
                for (var key in pages) {
                    if (getNextLink(pages[key]) === pageKey) {
                        setPageKey(key);
                        return;
                    }
                }
                setPageKey("");
            }
        };
        model.first();
        return model;
    };

    $rootScope.isLoading = function (name) {
        if (name != null) {
            return ($rootScope.requests[name] && $rootScope.requests[name] > 0);
        } else {
            return $http.pendingRequests.length > 0;
        }
    };

    $rootScope.requests = {};

    $rootScope.loadData = function (name, callback) {
        var deferred = $q.defer();

        var data = { name: name };

        if (name in $rootScope.requests) {
            $rootScope.requests[name] += 1;
        } else {
            $rootScope.requests[name] = 1;
        }

        $rootScope.$broadcast('startLoading', data);

        callback(deferred);

        function responseHandler() {
            if (name in $rootScope.requests) {
                $rootScope.requests[name] -= 1;
                if ($rootScope.requests[name] <= 0) {
                    delete $rootScope.requests[name];
                    $rootScope.$broadcast('stopLoading', data);
                }
            } else {
                $rootScope.$broadcast('stopLoading', data);
            }
        }

        deferred.promise.then(responseHandler, responseHandler);
        return deferred.promise;
    };

    $rootScope.inRoleSuperAdmin = function () {
        if ($rootScope.role)
            return $rootScope.role === "SuperAdmin";

        return false;
    };

    $rootScope.adminOrInRole = function (roles) {
        if ($rootScope.role) {
            if ($rootScope.role === "Admin" || $rootScope.role === "SuperAdmin")
                return true;
            if (roles)
                for (var j = 0; j < roles.length; j++) {
                    if ($rootScope.role === roles[j])
                        return true;
                }
        }
        return false;
    };
} ]);
